import { render } from "./Key.vue?vue&type=template&id=fd538e98&scoped=true"
import script from "./Key.vue?vue&type=script&lang=js"
export * from "./Key.vue?vue&type=script&lang=js"

import "./Key.vue?vue&type=style&index=0&id=fd538e98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd538e98"]])

export default __exports__